// extracted by mini-css-extract-plugin
export default {"page-layout":"styles_page-layout__3Mir6","unban-button":"styles_unban-button__LkzHL","placeholder-container":"styles_placeholder-container__-XoJg"};